/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_TERMINAL_HELP = {
  screenId: 'settings-terminal',
  label: 'Terminal de ventas',
  navPath: 'Configuración → Terminales de venta',
  keywords: ['terminal', 'punto de venta', 'caja', 'facturación', 'ventas'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Perfiles de venta con POS, caja, almacén, lista de precios y medios de cobro predeterminados.',
  sidebarItems: [{
    id: 'terminal',
    screenId: 'settings-terminal',
    label: 'Terminales de venta',
    description: 'Alta y configuración de terminales para facturar y cobrar.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Una terminal de venta agrupa todo lo que usa el vendedor al facturar: punto de venta AFIP, caja, almacén, lista de precios, moneda, tipos de comprobante y cuentas para cobrar (banco, QR, cheques, tarjetas).',
        },
        {
          title: 'Antes de empezar',
          paragraphs: [
            'Configurá antes: puntos de venta y relaciones POS–comprobante (Configuración → Comprobantes), cajas, almacenes, listas de precios, monedas y, si aplica, cuentas bancarias, QR de cobro, carteras de cheques y terminales de tarjetas.',
          ],
        },
        {
          title: 'Paso 1 — Ver la lista',
          steps: [
            'Entrá a Configuración → Terminales de venta.',
            'La lista muestra la descripción de cada terminal.',
            'Tocá la descripción para ver el detalle en una ventana.',
            'Tocá «Editar» en la fila para modificar.',
            'Botón + — nueva terminal.',
          ],
        },
        {
          title: 'Paso 2 — Datos principales (alta o edición)',
          fields: [
            { label: 'Descripción', description: 'Nombre visible de la terminal (obligatorio).' },
            { label: 'Punto de venta', description: 'POS AFIP vinculado; al cambiarlo se reinician los tipos de comprobante.' },
            { label: 'Caja', description: 'Caja donde impactan los movimientos (obligatorio).' },
            { label: 'Plantilla de facturación electrónica', description: 'Diseño del PDF de comprobantes electrónicos.' },
            { label: 'Lista de precios', description: 'Precios que se aplican al vender (obligatorio).' },
            { label: 'Almacén', description: 'Depósito del que se descuenta stock (obligatorio).' },
            { label: 'Moneda', description: 'Moneda principal de la terminal (obligatorio).' },
          ],
        },
        {
          title: 'Paso 3 — Tipos de comprobante',
          paragraphs: [
            'Tras elegir el POS, agregá uno o más tipos de comprobante habilitados para ese punto.',
            'Marcá «Predet.» en el que se usará por defecto al facturar.',
            'Es obligatorio al menos un tipo.',
          ],
        },
        {
          title: 'Paso 4 — Medios de cobro (opcional)',
          bullets: [
            'Cuentas bancarias, configuraciones QR, carteras de cheques y terminales de tarjetas.',
            'En cada bloque: elegí en el desplegable, «Agregar», y opcionalmente «Predet.» para el valor por defecto.',
            '«Quitar» elimina un ítem de la lista.',
          ],
        },
        {
          title: 'Guardar',
          paragraphs: ['Tocá «Guardar». Si falta algún dato obligatorio, el sistema lo indica antes de enviar.'],
        },
      ],
    },
  }],
}
